
import { Component, Vue, Prop, Watch, Emit, Ref } from 'vue-property-decorator'
import InfiniteLoading from '@xt/www/components/infinite-loadingv2/index.vue'
import { EnumCityStatus } from '@xt/client/entities/kindred-spirit/guild'
import type { ConfirmModalOptions } from '@xt/client/entities/kindred-spirit/kindred-spirit'
import InitConfirmModal from '../InitConfirmModal/index.vue'
import CityCard from '../CityCard/index.vue'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {
    CityCard,
    InfiniteLoading,
    InitConfirmModal
  }
})
export default class CityListGird extends Vue {
  @Prop({ default: 0 }) marginTop!: number
  @Prop({ default: false }) hasJoin: boolean

  @Ref()
  initConfirmModal: {
    show: (options?: ConfirmModalOptions) => Promise<boolean>
    hide: () => void
  }

  get body() {
    const statusArr = !this.hasJoin ? [EnumCityStatus.Assistance, EnumCityStatus.Inited] : [EnumCityStatus.Inited]

    return {
      statusArr: statusArr.join(',')
    }
  }

  get pagePagination() {
    return this.$store.$tonghao.Guild.pagePagination
  }

  get UserInfo() {
    return this.$store.$storeUser.UserInfo
  }

  get TonghaoStore() {
    return this.$store.$tonghao
  }

  get GuildStore() {
    return this.$store.$tonghao.Guild
  }

  async handleConfirm(data: number[] | null) {
    if (!data || !data.length || data.length <= 1) {
      this.$message.warn('请选择城市')
      return
    }

    const res = await this.GuildStore.createGuild(data[1])

    if (res === true) {
      this.$message.success('创建成功')

      await this.GuildStore.getHasJoinedCity()

      if (!this.GuildStore.joinedCity) return

      this.$emit('init-success', this.GuildStore.joinedCity.id)
    }
  }

  async handleShowInit() {
    if (!this.UserInfo.id) {
      this.$emit('unauthorized')
      return
    }

    this.initConfirmModal.show()
  }

  handleToCityPage(cityId: number) {
    if (!cityId) return

    if (this.$route.name === 'topic') {
      window.open(`/topic/city/${cityId}`, '_blank')
      return
    }

    this.$router.push({
      path: `/topic/city/${cityId}`
    })
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
